<template>
  <div class="header">
    <div class="header-left">
      <!-- PC端：显示首页图标 -->
      <i @click="returnHome" class="el-icon-house pc-home-icon"></i>
      <!-- 移动端：点击可显/隐侧边栏 -->
      <i class="mobile-toggle-icon" :class="isMobileSidebarVisible ? 'el-icon-close' : 'el-icon-menu'"
        @click="onToggleSidebar"></i>
    </div>
    <div class="header-center"></div>
    <div class="header-right">
      <el-button type="text" style="font-size: 20px;" icon="el-icon-bell" class="icon-button"></el-button>
      <el-dropdown style="padding: 10px; font-size: 20px;">
        <span class="el-dropdown-link">
          <i class="el-icon-setting"></i>
        </span>
        <el-dropdown-menu slot="dropdown">
          <!-- <el-dropdown-item>Settings</el-dropdown-item> -->
          <el-dropdown-item @click.native="handleLogout">Logout</el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
      <el-avatar icon="el-icon-user" :src="userData.avatar_url" size="medium" />
      <!-- <img :src="userData.avatar_url" style="width: 100px;"  alt=""> -->
      <span class="welcome-text">{{ userData.first_name }}</span>
    </div>
  </div>
</template>
<script>
import { logout } from "@/api/auth";
import { mapGetters, mapActions } from 'vuex';
export default {
  name: "AppHeader",
  props: {
    // 父组件(App.vue) 传来的布尔值，表示当前移动端侧边栏是否显示
    isMobileSidebarVisible: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    ...mapGetters("user", ["userData"]),
  },
  mounted() {
    this.fetchUserData(); // 加载用户数据
  },
  methods: {
    returnHome() {
      if (this.$route.path !== '/user') {
        this.$router.push('/');
      }
    },
    ...mapActions("user", ["fetchUserData", "updateUserData"]),
    onToggleSidebar() {
      this.$emit('toggle-mobile-sidebar');
    },
    async handleLogout() {
      const res = await logout();
      if (res.success) {
        this.$router.push('/sign_in')
      }
    }
  }
}
</script>

<style scoped>
.header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 60px;
  box-sizing: border-box;
  padding: 0 16px;
  background: #fff;
  border-bottom: 1px solid #ebeef5;
}

.header-left {
  display: flex;
  align-items: center;
  font-size: 20px;
}

/* PC端显示的首页图标，移动端隐藏 */
.pc-home-icon {
  display: inline-block;
  cursor: pointer;
}

.mobile-toggle-icon {
  display: none;
  /* 默认不显示，移动端再打开 */
  margin-left: 10px;
  cursor: pointer;
}

.header-center {
  flex: 1;
}

.header-right {
  display: flex;
  align-items: center;
}

.icon-button {
  margin-right: 10px;
  color: #606266;
}

.welcome-text {
  margin-left: 10px;
  font-size: 16px;
  color: #606266;
}

/* 
  在移动端(<=768px)：
    1) 隐藏 PC 的首页图标 
    2) 显示 mobile-toggle-icon(汉堡或叉号)
*/

@media (max-width: 768px) {
  .pc-home-icon {
    display: none;
  }

  .mobile-toggle-icon {
    display: inline-block;
  }
}
</style>